import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

export function ProductBuyBoxPricesSkeleton() {
  return (
    <div className="flex flex-col gap-1">
      <TextSkeleton className="w-18" size="sm" leading="light" />
      <TextSkeleton className="w-[14rem]" size="4xl" leading="compact" />
    </div>
  )
}
